sw_mwjp_widget.localization = {};
sw_mwjp_widget.localization.strings = {
    'en':
        {
            'title': "Jackpots",
            'dropAmount': "Drops before {0}"
        },
    'zh-cn':
        {
            'title': "必赢奖池",
            'dropAmount': "将在达到 {0} 前送出"
        },
    'th':
        {
            'dropAmount': "จะได้ก่อน {0}"
        },
    'vi':
        {
            'dropAmount': "Rơi trước {0}"
        },
    'id':
        {
            'dropAmount': "Jatuh sebelum<br/> {0}"
        },
    'ko':
        {
            'dropAmount': "{0} 전에 드롭"
        },
    'ro':
        {
            'dropAmount': "Cade până în {0}"
        }
};


sw_mwjp_widget.localization.getString = function (lang, str) {
    var str = sw_mwjp_widget.localization.strings[lang][str] || sw_mwjp_widget.localization.strings['en'][str] || null;
    return str;
}

sw_mwjp_widget.localization.getFormattedString = function (lang, str, arr) {
    var str = sw_mwjp_widget.localization.getString(lang, str);
    if (!str) return null;
    for (var i = 0; i < arr.length; i++) {
        var x = '\\{' + i + '}';
        str = str.replace(new RegExp(x, 'g'), arr[i])
    }
    return str;
}
// init
sw_mwjp_widget.localization.init = function () {
    var title = document.getElementById('widget-title');
    if (title) title.innerHTML = sw_mwjp_widget.localization.getString(sw_mwjp_widget.env.lang, 'title');
}
document.addEventListener("environment-loaded", sw_mwjp_widget.localization.init);